export type BootstrapFailureReason =
  | "invalid-api-base-url"
  | "missing-api-base-url"
  | "masked-project-api-key"
  | "missing-hostname"
  | "missing-project-api-key";

export type BootstrapScriptElement = {
  dataset?: {
    projectApiKey?: string;
  };
  getAttribute?(name: string): string | null;
};

export type ParseBootstrapSourceInput = {
  hostname?: string | null;
  projectApiKey?: string | null;
  scriptElement?: BootstrapScriptElement | null;
};

export type BootstrapSourceResult =
  | {
      hostname: string;
      ok: true;
      projectApiKey: string;
    }
  | {
      ok: false;
      reason: BootstrapFailureReason;
    };

function readProjectApiKey(input: ParseBootstrapSourceInput) {
  return (
    input.projectApiKey ??
    input.scriptElement?.dataset?.projectApiKey ??
    input.scriptElement?.getAttribute?.("data-project-api-key") ??
    ""
  ).trim();
}

export function parseBootstrapSource(
  input: ParseBootstrapSourceInput,
): BootstrapSourceResult {
  const projectApiKey = readProjectApiKey(input);
  if (!projectApiKey) {
    return { ok: false, reason: "missing-project-api-key" };
  }

  if (projectApiKey.includes("*")) {
    return { ok: false, reason: "masked-project-api-key" };
  }

  const hostname = input.hostname?.trim() ?? "";
  if (!hostname) {
    return { ok: false, reason: "missing-hostname" };
  }

  return {
    ok: true,
    projectApiKey,
    hostname,
  };
}

export function getBrowserHostname() {
  try {
    return window.location.hostname;
  } catch {
    return "";
  }
}

export function getCurrentScriptElement() {
  return document.currentScript as HTMLScriptElement | null;
}
